import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIRouterModule } from '@uirouter/angular';
import * as Management from '.';
import { SharedModule } from '../../shared/shared.module';
import { InvoiceChargeNumberComponent } from './invoice-charge-number/invoice-charge-number.component';
import { InvoiceCycleComponent } from './invoice-cycle/invoice-cycle.component';
import { InvoiceManagementContainerComponent } from './invoice-management-container/invoice-management-container.component';
import { InvoiceManagementRoute } from './invoice-management.route';
import { InvoiceManagementComponent } from './invoice-management/invoice-management.component';

@NgModule({
    declarations: [
        InvoiceManagementContainerComponent,
        InvoiceManagementComponent,
        InvoiceChargeNumberComponent,
        InvoiceCycleComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [InvoiceManagementRoute]
        }),
        EffectsModule.forFeature([
            Management.Invoice.InvoiceEffects,
            Management.ChargeNumber.InvoiceChargeNumberEffects,
            Management.SessionNumber.InvoiceSessionNumberEffects
        ]),
        StoreModule.forFeature(
            Management.Invoice.invoicesFeatureKey,
            Management.Invoice.reducer
        ),
        StoreModule.forFeature(
            Management.ChargeNumber.invoiceChargeNumbersFeatureKey,
            Management.ChargeNumber.reducer
        ),
        StoreModule.forFeature(
            Management.SessionNumber.invoiceSessionNumbersFeatureKey,
            Management.SessionNumber.reducer
        )
    ]
})
export class InvoiceManagementModule {}
